import { completarLogic } from '../completar/completar.logic';
import { CompletarHostView, CompletarProjectorView, CompletarStudentView } from '../eval-blocks/EvalBlocksViews';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';

export const completarPlugin: ActivityPlugin<'completar'> = {
  ...completarLogic,
  displayName: GAME_MODE_CATALOG.completar.displayName,
  icon: GAME_MODE_CATALOG.completar.icon,
  HostView: CompletarHostView,
  StudentView: CompletarStudentView,
  ProjectorView: CompletarProjectorView,
};

export { demoCompletarPayload } from '../completar/completar.logic';
